<template>
	<div class="py-4 container-fluid">
		<div class="row">
			<div class="col-12">
				<div class="card mb-4">
					<div class="card-header pb-0">
						<h4>Maneggio</h4>
						<!-- <button
							type="button"
							id="add-btn"
							class="btn btn-primary"
							@click="clear"
							data-bs-toggle="modal"
							data-bs-target="#formModal"
						>
							+ {{ $t('add').toUpperCase() }}
						</button> -->
					</div>
					<div class="card-body px-0 pt-0 pb-2">
						<img src="./maneggio.jpg" alt="" />
					</div>
				</div>
			</div>
		</div>

		<!-- <div
			class="modal fade"
			id="formModal"
			data-bs-backdrop="static"
			data-bs-keyboard="false"
			tabindex="-1"
			aria-labelledby="add"
			aria-hidden="true"
		>
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="formModalBtn">{{ modalTitle }}</h5>
						<button
							type="button"
							class="btn-close"
							data-bs-dismiss="modal"
							aria-label="Close"
							style="color: black; font-size: 2rem"
						>
							<span
								aria-hidden="true"
								class="d-block"
								style="margin-top: -0.5rem"
								>&times;</span
							>
						</button>
					</div>
					<div class="modal-body">
						<Vueform ref="form$" v-model="member" sync>
							<HiddenElement name="id" />
							<text-element
								name="first_name"
								:label="$t('first_name')"
								rules="required"
							></text-element>
							<text-element
								name="last_name"
								:label="$t('last_name')"
								rules="required"
							></text-element>
							<text-element
								name="username"
								:label="$t('username')"
								rules="required"
							></text-element>
							<text-element
								name="email"
								:label="$t('email')"
								rules="required|email"
							></text-element>
							<text-element
								name="password"
								input-type="password"
								:label="$t('password')"
								rules="required"
							></text-element>
							<text-element
								name="location"
								:label="$t('location')"
								rules=""
							></text-element>
							<text-element
								name="profession"
								:label="$t('profession')"
								rules=""
							></text-element>
							<text-element
								name="phone_number"
								:label="$t('phone_number')"
								rules=""
							></text-element>
							<hr />
							<MultifileElement
								name="photo_url"
								:object="true"
								url="https://equiup-api.13bit.dev/api/horse-images/get-photo"
								preview-url="https://equiup-api.13bit.dev/api/horse-images/get-thumbnail"
								:upload-temp-endpoint="false"
								label="Upload Foto"
								view="gallery"
								:clickable="true"
								:drop="true"
								storeFile="url"
								:soft-remove="true"
							/>
						</Vueform>
					</div>
					<div class="modal-footer">
						<button
							type="button"
							id="close"
							class="btn btn-secondary"
							data-bs-dismiss="modal"
						>
							Chiudi
						</button>
						<button
							type="button"
							class="btn btn-primary"
							:class="{ loading: loading }"
							@click="save"
						>
							Salva
						</button>
					</div>
				</div>
			</div>
		</div> -->
	</div>
</template>

<script>
	export default {
		created() {
			this.$store.dispatch('updateBreadcrumbs', [
				{ title: 'Maneggio', name: 'Maneggio' },
			]);
		},
	};
</script>
